import script from "./ForgetModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgetModal.vue?vue&type=script&setup=true&lang=js"

import "./ForgetModal.vue?vue&type=style&index=0&id=787f9ed9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-787f9ed9"]])

export default __exports__